import { useContext } from 'react';
import { DinPlayerContext } from '../components/DinPlayerProvider';
export var useDinPlayerContext = function () {
    var context = useContext(DinPlayerContext);
    return context;
};
